<div class="card">
    <div class="details" *ngIf="data?.deaNumber" @fadeInOut>
        <div class="first-row">
            <div>
                <span class="prop">{{type === OrderPartyTypeEnum.Supplier || type === OrderPartyTypeEnum.EdiSupplier ? 'Supplier:' : 'Buyer:'}} </span>
                <span class="prop-val">{{data?.orderParty?.companyName}}</span>
                <div class="label" [class.hidden]="!isPharmacy">
                    <div class="text">You</div>
                </div>
            </div>
            <app-three-dots-menu class="menu" *ngIf="!readOnly"
                [options]="menuOptions" (selected)="menuItemSelected($event)">
            </app-three-dots-menu>
        </div>
       
        <div>
            <span class="prop">Physical Address:</span>
            <span class="prop-val">{{data?.physicalAddress?.address1}},<span *ngIf="data?.physicalAddress?.address2"> {{data?.physicalAddress?.address2}},</span> {{data?.physicalAddress?.city}}, {{data?.physicalAddress?.state}} {{data?.physicalAddress?.zipCode}}</span>
        </div>
        <div>
            <span class="prop">Ship {{type === OrderPartyTypeEnum.Supplier || type === OrderPartyTypeEnum.EdiSupplier ? 'From' : 'To'}}:</span>
            <span class="prop-val">{{data?.shippingAddress?.address1}},<span *ngIf="data?.shippingAddress?.address2"> {{data?.shippingAddress?.address2}},</span> {{data?.shippingAddress?.city}}, {{data?.shippingAddress?.state}} {{data?.shippingAddress?.zipCode}}</span>
        </div>
        <div class="flex">
            <span class="prop">DEA Number:</span>
            <span class="prop-val">{{data?.deaNumber}}</span>
            <div [hidden]="!data?.contactPerson?.firstName">
                <span class="border border-gray-400 mx-2"></span>
                <span class="prop">Contact Person:</span>
                <span class="prop-val">{{data?.contactPerson?.firstName}} {{data?.contactPerson?.lastName}}</span>
            </div>
           
        </div>
    </div>
    <div>
        <app-autocomplete *ngIf="!(loading$ | async) && !data?.id && (type === OrderPartyTypeEnum.Buyer || type === OrderPartyTypeEnum.EdiSupplier)"
            class="autocomplete"
            [data]="autocompleteData" searchKeyword="name"
            [control]="control"
            [label]="autocompleteLabel"
            [placeholder]="autocompletePlaceholder"
            (itemAdded)="addBuyer()"
            (selected)="partySelected($event)"
            #autocomplete
        >
        </app-autocomplete>
    </div>
 
</div>


<app-add-edit-order-party type="1" *ngIf="addModifyDialog" 
    [data]="data"
    [type]="type"
    (submitted)="saveSubmitted($event)"
    (cancel)="addModifyDialog = false">
</app-add-edit-order-party>